module.exports = __webpack_public_path__ + "static/media/howtobefat_img_3.b5da9416.png";